import React from 'react'
import styled from 'styled-components'
import { Link } from '../atoms/Link'

const LP_URL = 'https://airregi.jp/order'

export const FooterDescription = () => {
  return (
    <Description>
      導入相談をお急ぎの場合は、Webサイトからお問い合わせください。
    </Description>
  )
}

export const Footer = () => {
  return (
    <FooterArea>
      <Link href={LP_URL} size={14}>
        Airレジ オーダー Webサイト
      </Link>
      <LinkDescription>
        詳しい情報や資料ダウンロードはこちらから
      </LinkDescription>
    </FooterArea>
  )
}

const Description = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  color: #606060;
  font-size: 11px;
  font-weight: 300;
  line-height: 14px;
  text-align: left;
`

const FooterArea = styled.div`
  padding: 20px 0;
  width: 100%;
  background: #fafafa;
  position: absolute;
  bottom: 0;
  text-align: center;
`

const LinkDescription = styled.div`
  color: #606060;
  font-size: 10px;
  font-weight: 300;
  line-height: 14px;
`
